import { Form } from "formik";
import styled from "styled-components";
import { colorTheme, textTheme } from "../../theme";

export const Container = styled.div`
  width: 100%;
`;

export const ColumnContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
`;

export const FlatButton = styled.button`
  font-size: 100%;
  font-family: inherit;
  border: 0;
  padding: 0;
  background: none;
  ${textTheme.subtitle2};
  color: ${colorTheme.black};
  text-align: start;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  cursor: pointer;
  width: max-content;

  &:hover,
  &.selected {
    color: ${colorTheme.newBlue};
  }
`;

export const BlueButton = styled(FlatButton)`
  ${textTheme.button};
  background: ${colorTheme.newBlue};
  box-shadow: 0px 4px 10px rgba(16, 156, 241, 0.06);
  border-radius: 4px;
  color: ${colorTheme.white};
  padding: 12px 18px;
  &:hover,
  &.selected {
    color: ${colorTheme.white};
  }
`;

export const OutlineButton = styled(BlueButton)`
  background: ${colorTheme.white};
  border: 1px solid ${colorTheme.newBlue};
  box-sizing: border-box;
  box-shadow: 0px 4px 10px rgba(16, 156, 241, 0.06);
  border-radius: 4px;
  color: ${colorTheme.newBlue};
  &:hover,
  &.selected {
    color: ${colorTheme.newBlue};
  }
`;

export const RemoveButton = styled(FlatButton)`
  padding-left: 11px;
  padding-top: 11px;
  color: ${colorTheme.grayDark};
  > svg {
    width: 20px;
    height: 23px;
  }
`;

export const SaveButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 20px;
`;
